(function() {
  'use strict';

  const STORAGE_PREFIX = 'jc_popup_';
  const QUEUE_LIMIT = 2;

  const popupQueue = [];
  let isShowing = false;

  function getStorageKey(popupId) {
    return STORAGE_PREFIX + popupId;
  }

  function isAlreadyShown(popupId) {
    try {
      return sessionStorage.getItem(getStorageKey(popupId)) === 'shown';
    } catch (e) {
      return false;
    }
  }

  function markAsShown(popupId) {
    try {
      sessionStorage.setItem(getStorageKey(popupId), 'shown');
    } catch (e) {
      console.warn('[jc-popup] sessionStorage write failed:', e);
    }
  }

  function showPopup(popupEl) {
    if (isShowing && popupEl.dataset.triggerType !== 'page_load_critical') {
      // 既に表示中の場合はキューに追加
      if (!popupQueue.find(p => p.dataset.popupId === popupEl.dataset.popupId)) {
        popupQueue.push(popupEl);
      }
      return;
    }

    isShowing = true;
    popupEl.classList.add('is-active');
    document.body.classList.add('popup-active');

    if (popupEl.dataset.showOnce === 'true') {
      markAsShown(popupEl.dataset.popupId);
    }
  }

  function dismissPopup(popupEl) {
    popupEl.classList.remove('is-active');
    document.body.classList.remove('popup-active');
    isShowing = false;

    // キューから次を取り出して表示
    if (popupQueue.length > 0) {
      const next = popupQueue.shift();
      // priority 降順で再ソート（複数キューイングされた場合）
      popupQueue.sort((a, b) =>
        parseInt(b.dataset.priority || 0) - parseInt(a.dataset.priority || 0)
      );
      setTimeout(() => showPopup(next), 200);
    }
  }

  function handleConfirm(popupEl) {
    // 「はい(同意)」を押したときだけ shown を記録
    if (popupEl.dataset.showOnce === 'true') {
      markAsShown(popupEl.dataset.popupId);
    }

    const ctaUrl = popupEl.dataset.ctaUrl;
    if (ctaUrl && ctaUrl.trim() !== '') {
      window.location.href = ctaUrl;
    } else {
      dismissPopup(popupEl);
    }
  }

  function handleCancel(popupEl) {
    // 年齢確認の「いいえ」ボタン: 前のページに戻る or トップへ
    if (window.history.length > 1 && document.referrer) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }

  function attachListeners(popupEl) {
    const confirmBtn = popupEl.querySelector('[data-popup-confirm]');
    const cancelBtn = popupEl.querySelector('[data-popup-cancel]');
    const dismissBtns = popupEl.querySelectorAll('[data-popup-dismiss]');

    if (confirmBtn) {
      confirmBtn.addEventListener('click', () => handleConfirm(popupEl));
    }
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => handleCancel(popupEl));
    }
    dismissBtns.forEach(btn => {
      // critical（年齢確認）はオーバーレイ・close ボタンで閉じれない
      if (popupEl.dataset.triggerType === 'page_load_critical') return;
      btn.addEventListener('click', () => dismissPopup(popupEl));
    });

    // ESC キーで閉じる（critical 以外）
    if (popupEl.dataset.triggerType !== 'page_load_critical') {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popupEl.classList.contains('is-active')) {
          dismissPopup(popupEl);
        }
      });
    }
  }

  function processPopups() {
    const popups = document.querySelectorAll('.jc-popup-modal');
    if (popups.length === 0) return;

    // critical を最優先で処理
    const criticalPopups = [];
    const normalPopups = [];

    popups.forEach(popup => {
      attachListeners(popup);

      if (popup.dataset.triggerType === 'page_load_critical') {
        criticalPopups.push(popup);
      } else {
        normalPopups.push(popup);
      }
    });

    // critical 処理: Liquid 側で is-active 付与済み。sessionStorage チェックで除去
    criticalPopups.forEach(popup => {
      if (popup.dataset.showOnce === 'true' && isAlreadyShown(popup.dataset.popupId)) {
        popup.classList.remove('is-active');
      } else {
        // 表示状態維持
        document.body.classList.add('popup-active');
        isShowing = true;
        // markAsShown は handleConfirm(「はい」クリック時)で実行する
      }
    });

    // normal 処理: priority 降順ソート → 上位 QUEUE_LIMIT 個のみ起動
    normalPopups.sort((a, b) =>
      parseInt(b.dataset.priority || 0) - parseInt(a.dataset.priority || 0)
    );

    if (normalPopups.length > QUEUE_LIMIT) {
      console.warn('[jc-popup] Too many popups matched, limiting to', QUEUE_LIMIT);
    }

    const activePopups = normalPopups.slice(0, QUEUE_LIMIT);

    activePopups.forEach(popup => {
      // show_once チェック
      if (popup.dataset.showOnce === 'true' && isAlreadyShown(popup.dataset.popupId)) {
        return;
      }

      const triggerType = popup.dataset.triggerType;
      const delayMs = parseInt(popup.dataset.delaySeconds || 0) * 1000;

      switch (triggerType) {
        case 'page_load':
          if (criticalPopups.some(p => p.classList.contains('is-active'))) {
            // critical 表示中の場合はキューに入れる
            popupQueue.push(popup);
          } else {
            setTimeout(() => showPopup(popup), delayMs);
          }
          break;

        case 'scroll':
          attachScrollTrigger(popup);
          break;

        case 'exit_intent':
          attachExitIntent(popup);
          break;

        case 'click':
          attachClickTrigger(popup);
          break;
      }
    });
  }

  function attachScrollTrigger(popup) {
    let triggered = false;
    const threshold = 0.5; // ページ高さの 50% スクロールで発火

    function checkScroll() {
      if (triggered) return;
      const scrolled = window.scrollY + window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      if (scrolled / fullHeight >= threshold) {
        triggered = true;
        showPopup(popup);
        window.removeEventListener('scroll', checkScroll);
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
  }

  function attachExitIntent(popup) {
    let triggered = false;

    function trigger() {
      if (triggered) return;
      triggered = true;
      showPopup(popup);
    }

    // PC: マウスが画面上部から離脱
    document.addEventListener('mouseleave', (e) => {
      if (e.clientY < 0 && !triggered) trigger();
    });

    // Mobile: pagehide
    window.addEventListener('pagehide', () => {
      if (!triggered) trigger();
    }, { once: true });
  }

  function attachClickTrigger(popup) {
    const popupId = popup.dataset.popupId;
    const triggers = document.querySelectorAll(`[data-popup-trigger="${popupId}"]`);
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        showPopup(popup);
      });
    });
  }

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processPopups);
  } else {
    processPopups();
  }
})();
